import type { ActionButtonSize } from 'client-ribbons-design-system/types/actionButtons';
import type { IconSize } from 'client-ribbons-design-system/types/icons';

export const ACTION_BUTTON_SIZE_MAP: Record<ActionButtonSize, Exclude<IconSize, 32>> = {
  small: 16,
  large: 24,
};
